const testimonials = [
  {
    name: "Jennifer L.",
    location: "Duluth, GA",
    rating: 5,
    text: "Our family cruise to the Caribbean was in 8 days and my son's passport had expired. Fast Passport Center walked us through the child passport process, told us exactly which clerk to visit in Duluth, and had his expedited passport back in 5 days. Absolute lifesaver.",
    service: "Child Passport",
  },
  {
    name: "Michael S.",
    location: "Suwanee, GA",
    rating: 5,
    text: "Business trip to Toronto moved up to 4 days out. Called from my office in Suwanee, started online that afternoon, shipped from Duluth overnight, and had my emergency passport in hand in 3 days. The team kept me updated every step of the way.",
    service: "Emergency Passport",
  },
  {
    name: "Rachel T.",
    location: "Lawrenceville, GA",
    rating: 5,
    text: "I lost my passport a week before a wedding in Mexico. Fast Passport Center made the replacement process so simple — they told me exactly what forms to fill out, where to get photos in Lawrenceville, and had my expedited passport to me with a day to spare.",
    service: "Lost Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function DuluthTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Gwinnett County Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Duluth, Suwanee, Lawrenceville, and north metro Atlanta who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}